import { Component, inject } from '@angular/core';
import { TrolyComponent } from 'src/app/core/components/troly.component';
import { ConfigService } from 'src/app/core/services/config.service';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
	standalone: false
})

/**
 * Footer component
 */
export class FooterComponent extends TrolyComponent {

	override readonly __name: string = 'FooterComponent';
	
	// set the currenr year
	year: number = new Date().getFullYear();

	public appConfig: ConfigService = inject(ConfigService)

	get dbRegion():string {
		return this.localCache.cachedUiKey('db', 'us-nyc');
	}

}
